import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  getUserRole(): string | null {
    return sessionStorage.getItem('role');
  }

  logout(): void {
    sessionStorage.removeItem('role');
  }

  constructor() { }
}
